import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { AdminProvider } from './context/AdminContext'
import { ThemeProvider } from './context/ThemeContext'
import { UserProvider } from './context/UserContext'
import { loadPortalConfig } from './services/portal'

// Fetch runtime config (portal URL) from the Go server before mounting.
// One extra round-trip on cold start; on failure we mount anyway and SSO
// redirects log a warning. See services/portal.ts.
loadPortalConfig().finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ThemeProvider>
        <UserProvider>
          <AdminProvider>
            <App />
          </AdminProvider>
        </UserProvider>
      </ThemeProvider>
    </StrictMode>
  )
})
